export enum ManualLinkSetupSteps {
  IntroName = 'ManualLinkSetupSteps.IntroName',
  AccountName = 'ManualLinkSetupSteps.AccountName',
  Balances = 'ManualLinkSetupSteps.Balances',
  Income = 'ManualLinkSetupSteps.Income',
}
